module.exports = __webpack_public_path__ + "static/pattern-widget-chart-05f772e9894b6d6e462c98fceb2bd342.png";